import React from 'react'
import { Typography, TypographyProps } from './Typography'

export type HeadingLevel = 1 | 2 | 3 | 4

export interface HeadingProps extends Omit<TypographyProps, 'variant'> {
  /**
   * 見出しのレベル（1-4）
   */
  level: HeadingLevel
}

/**
 * 見出し要素専用のコンポーネント
 * Typography の便利なラッパーとして機能します
 * Figmaデザインに合わせてh1-h4まで対応
 */
export const Heading: React.FC<HeadingProps> = ({
  level,
  bold = true, // 見出しはデフォルトで太字
  ...props
}) => {
  const headingVariant = `h${level}` as TypographyProps['variant']

  return (
    <Typography
      variant={headingVariant}
      bold={bold}
      {...props}
    />
  )
}
